import { LabelFunctions, HelpFunctions } from '../types';
import { SupportingActivityItemModel } from '../../api/models';

export const alternateOtherOrganisationName = (values: Partial<SupportingActivityItemModel>, defaultLabel: string) => {
    if (values.otherOrganisation !== undefined && values.otherOrganisation === 'YesCRC') {
        return 'Which Cooperative Research Centre conducted some or all of this activity?';
    }
    if (values.otherOrganisation !== undefined && values.otherOrganisation !== 'No') {
        return 'Which Research Service Provider conducted some or all of this activity?';
    }
    return defaultLabel;
};

export const alternateBriefDescription = (values: Partial<SupportingActivityItemModel>, defaultLabel: string) => {
    if (values.otherOrganisation !== undefined) {
        switch (values.otherOrganisation) {
            case 'YesCRC':
                return `A brief description of the services provided by the Cooperative Research Centre.`;
            case 'YesRSP':
                return `A brief description of the services provided by the Research Service Provider.`;
            case 'YesRSPLevy':
                return `A brief description of the services provided by the Research Service Provider.`;
        }
    }
    return defaultLabel;
};

export const alternateSupportingActivityContentKeys = (values: Partial<SupportingActivityItemModel>, defaultContentKeys: string[]) => {
    if (values.otherOrganisation !== undefined) {
        const { otherOrganisation } = values; return defaultContentKeys.map(key => {
            switch (otherOrganisation) {
                case 'YesCRC': switch (key) {
                    case 'supportingActivityBriefDescription': return 'supportingActivityCrcBriefDescription';
                    case 'SupportingActivityWhichRspCrc': return 'SupportingActivityWhichCrc';
                    default: return key;
                } case 'YesRSPLevy': switch (key) {
                    case 'supportingActivityBriefDescription': return 'supportingActivityLevyRspBriefDescription';
                    case 'SupportingActivityWhichRspCrc': return 'SupportingActivityWhichRsp';
                    default: return key;
                } case 'No': return key; default: switch (key) {
                    case 'supportingActivityBriefDescription': return 'supportingActivityRspBriefDescription';
                    case 'SupportingActivityWhichRspCrc': return 'SupportingActivityWhichRsp';
                    default: return key;
                }
            }
        });
    }
    return defaultContentKeys;
};

export const supportingActivities: LabelFunctions<SupportingActivityItemModel> = {
    otherOrganisationName: alternateOtherOrganisationName,
    briefDescription: alternateBriefDescription,
};

export const supportingActivitiesHelp: HelpFunctions<SupportingActivityItemModel> = {
    contentKeys: alternateSupportingActivityContentKeys,
};
